export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-8.803a733a.png";